
import Vue from "vue";
import AppDelayedProgress from "./DelayedProgress.vue";
export default Vue.extend({
	data(){
		return {
			spinnerShown: false
		};
	},
	components: {
		AppDelayedProgress
	}
});
